import { render } from "./_menu.vue?vue&type=template&id=2e057dfc"
import script from "./_menu.vue?vue&type=script&lang=js"
export * from "./_menu.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/products/_menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e057dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e057dfc', __exports__)) {
    console.log('reload')
    api.reload('2e057dfc', __exports__)
  }
  
  module.hot.accept("./_menu.vue?vue&type=template&id=2e057dfc", () => {
    console.log('re-render')
    api.rerender('2e057dfc', render)
  })

}


export default __exports__